import PropTypes from '../../_util/vue-types';

export default {
  name: 'ColumnGroup',
  props: {
    title: PropTypes.any
  },
  isTableColumnGroup: true
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-table/src/ColumnGroup.js
// module id = 870
// module chunks = 0